<template>
  <div class="layout-wrapper">

    <p class="title">{{ title }}</p>

    <div class="inner-wrapper">

      <slot></slot>

    </div>

  </div>
</template>

<script>
export default {
  name: 'GroupLayout',
  props: {
    title: String,
  },
};
</script>

<style lang="scss" scoped>
.layout-wrapper {
  width: 100%;
  max-width: 320px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 20px;

  .title {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
  }

  .inner-wrapper {
    width: 100%;

    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }
}

@media screen and (max-width: 1024px) {
  .layout-wrapper {
    width: 100%;
    max-width: none;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/dashboard/components/GroupLayout.vue